import { render, staticRenderFns } from "./PaymentRemarksList.vue?vue&type=template&id=7da44c72&scoped=true&"
import script from "./PaymentRemarksList.vue?vue&type=script&lang=js&"
export * from "./PaymentRemarksList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRemarksList.vue?vue&type=style&index=0&id=7da44c72&lang=scss&scoped=true&"
import style1 from "./PaymentRemarksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da44c72",
  null
  
)

export default component.exports